// src/pages/HomePage.jsx
import React from 'react';
import styled from 'styled-components';

// Import all redesigned sections
import RedesignedHero from '../components/Hero/RedesignedHero';
import RedesignedAbout from '../components/AboutMe/RedesignedAbout';
import RedesignedLearning from '../components/CurrentlyLearning/RedesignedLearning';
import RedesignedProjects from '../components/Projects/RedesignedProjects';
import RedesignedContact from '../components/Contact/RedesignedContact';

const PageContainer = styled.div`
  overflow: hidden; // Ensure no horizontal scrolling occurs
`;

const HomePage = () => {
  return (
    <PageContainer>
      <RedesignedHero />
      <RedesignedAbout />
      <RedesignedLearning />
      <RedesignedProjects />
      <RedesignedContact />
    </PageContainer>
  );
};

export default HomePage;